import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useHistory } from 'react-router-dom';

import DangerButton from '../../components/button/Danger';
import Button from '../../components/button/Default';
import Loader from '../../layouts/admin/Loader';
import { getIsIncidentActive, updateIncidentStatus } from '../../services/incidents.service';
import maintenanceImage from './maintenanceImage.png';

const useStyles = makeStyles((theme) => {
    const image = {
        'max-height': '70vh',
    };
    const text = {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        fontWeight: 'bold',
        fontFamily: 'Gotham',
    };

    return {
        gridItem: {
            textAlign: 'center',
            // "max-height": '70vh'
        },
        text,
        headingText: {
            ...text,
            fontWeight: 'bold',
        },
        image,
        'inactive-image': {
            ...image,
            filter: 'grayscale(100%)',
        },
    };
});

const CriticalIncidents = () => {
    const [isIncidentActive, setIsIncidentActive] = useState(null);
    const classes = useStyles();

    const toggleIncident = () => {
        confirmAlert({
            title: isIncidentActive ? 'Re-enable App' : 'Disable App',
            message: isIncidentActive
                ? 'Are you sure you want to re-enable the app?'
                : 'Are you sure you want to disable the app? Users will no longer be able to interact with the app.',
            buttons: [
                {
                    label: `${isIncidentActive ? 'Exit' : 'Enter'} maintenance mode`,
                    onClick: async () => {
                        const isActive = await updateIncidentStatus(!isIncidentActive);
                        setIsIncidentActive(isActive);
                    },
                },
                {
                    label: 'Cancel',
                },
            ],
        });
    };

    useEffect(() => {
        const checkStatus = async () => setIsIncidentActive(await getIsIncidentActive());
        checkStatus();
    }, []);

    return (
        <>
            <Header />
            {isIncidentActive === null ? (
                <Loader />
            ) : (
                <Box
                    flex={1}
                    mx={6}
                    display="flex"
                    flexDirection="column"
                    justifyContent="baseline"
                    alignItems="center"
                >
                    <Typography className={classes.headingText}>
                        {isIncidentActive ? 'Critical Incident is Active' : 'There are no active Critical Incidents'}
                    </Typography>
                    <Box height="50%">
                        <Grid alignItems="center" container spacing={3}>
                            <Grid item xs={6} className={classes.gridItem}>
                                <Box flexDirection="column" justifyContent="space-around">
                                    <Typography>
                                        {isIncidentActive
                                            ? 'The app is currently in maintenance mode. Users are being prevented from interacting with the app.'
                                            : 'Do you want to enable maintenance mode? Users will be prevented from interacting with the app.'}
                                    </Typography>
                                    <DangerButton onClick={toggleIncident}>
                                        {isIncidentActive ? 'Re-enable App' : 'Disable App'}
                                    </DangerButton>
                                </Box>
                            </Grid>
                            <Grid item xs={6} className={classes.gridItem}>
                                <img
                                    alt="screenshot of maintenance page"
                                    className={isIncidentActive ? classes.image : classes['inactive-image']}
                                    src={maintenanceImage}
                                ></img>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            )}
        </>
    );
};

const Header = () => {
    const history = useHistory();

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" mx={6} my={4}>
            <Button onClick={history.goBack} key="back">
                Go Back
            </Button>
        </Box>
    );
};

export default CriticalIncidents;
